import React, {Component} from 'react'; 
import cx from 'classnames'; 
import './news-slider.css'; 

export class PureNewsSlider extends Component {

    render()
    {
        const { news, newsNumber } = this.props 

        if (news.length === 0) return null
        
        const titles = news.items.slice(0, newsNumber).map((article, i) => this.renderTitle(article, i))
        const details = news.items.slice(0, newsNumber).map((article, i) => this.renderPreview(article, i))
            
        return(
            <div className="news-holder">
                <ul className="news-headlines">
                    {titles}
                </ul>
                <div className="news-preview">
                    {details}
                </div>
            </div>
        )
    }  

    renderTitle = (article, position) => {

        const { selectedArticle, onClick } = this.props
        const isSelected = selectedArticle === position ? "selected" : "" 
        return(<li className={isSelected} key={position} onClick={() => onClick(position)}>{article.title}</li>)
    }

    renderPreview = (article, position) => {
        const { selectedArticle, newsNumber, primaryColor, secondaryColor} = this.props
        const showContent = selectedArticle === position
        const imageUrl = article.image.split("|")[0]
        return (
        <div className={cx('news-content', {"top-content": showContent})} style={{position: 'relative', height:`${newsNumber*75-1}px`}} key={position}>
            <div style={{position: 'absolute', top: 0, left: 0, right: 0, bottom :0,
                backgroundImage:`url("${imageUrl}")`,
                backgroundPosition: 'center', backgroundSize: 'cover'}} />
            <div className="resume" style={{background:`linear-gradient(to top, ${primaryColor}, ${secondaryColor})`}}>
                <h3 className="title">{article.title}</h3>
                <p>{article.description.split("...")[0]}...</p>
            </div>
        </div>)
    }


}

export class NewsSlider extends Component {

    state = {
        selectedArticle : 0
    }

    /*componentDidMount(){
        this._isMounted = true
        for(let i=0; i<5; i++){
          setTimeout(() => this.handleClick(i), 10000)
        }
    }
    
      componentWillUnmount(){
        this._isMounted = false
      }*/

    handleClick = (position) => {
        this.setState({selectedArticle:position})
    }

    render()
    {
        return(
            <PureNewsSlider {...this.props} {...this.state} onClick={this.handleClick}/>
        )
        
    }
}



// WEBPACK FOOTER //
// ./src/components/News/NewsSlider/index.js